<template>
  <div class="accordion-item">
    <h2 class="accordion-header" :id="headingId">
      <button class="accordion-button noMarginLeft" :class="isCollapsed" type="button" aria-expanded="false" data-bs-toggle="collapse" :data-bs-target="'#' + collapseId" :aria-controls="collapseId" @click="$emit('select', index)">
        {{exercise.name}}
        <div class="marginLeft">
        <span v-for="index in exercise.sets" :key="index">
          <BIconCircleFill v-if="exercise.current && exercise.current.length >= index" class="icon"></BIconCircleFill>
          <BIconCircle v-else class="icon"></BIconCircle>
        </span>
        </div>
      </button>

    </h2>
    <div v-if="inlineDetail" :id="collapseId" class="accordion-collapse collapse" :class="isCollapsedShow" :aria-labelledby="headingId" data-bs-parent="#exercises">
      <ExerciseDetail
        :exercise="exercise"
        :index="index"
        @open-modal="(i, s) => $emit('open-modal', i, s)"
        @restart-timer="$emit('restart-timer')"
        @warmup-set-done="(ex, idx) => $emit('warmup-set-done', ex, idx)"
      />
    </div>
  </div>
</template>

<script>

import {
  BIconCircle,
  BIconCircleFill,
} from 'bootstrap-icons-vue';
import ExerciseDetail from '@/components/ExerciseDetail';

export default {
  name: 'ExerciseView',
  props: {
    index: Number,
    exercise: {name: String, sets: Number, previous: Array, current: Array},
    selectedIndex: Number,
    inlineDetail: { type: Boolean, default: true },
  },
  emits: ['select', 'open-modal', 'restart-timer', 'warmup-set-done'],
  components: {
    BIconCircle,
    BIconCircleFill,
    ExerciseDetail,
  },
  computed: {
    isCollapsed() {
      return this.index === this.selectedIndex ? '' : 'collapsed'
    },
    isCollapsedShow() {
      return this.index === this.selectedIndex ? 'show' : ''
    },
    collapseId() {
      return 'collapse' + this.index
    },
    headingId() {
      return 'heading' + this.index
    },
  }
}
</script>

<style>
.noMarginLeft::after {
  margin-left: 10px !important;
}
.marginLeft {
  margin-left: auto;
}
.icon {
  margin-left: 1px;
  height: 10px;
}
</style>
